import React from 'react'

import Avatar, { AvatarProps } from 'components_new/atoms/Avatar'
import Icon from 'components_new/atoms/Icon'

import Logotype from 'components_new/molecules/Logotype'

import LogotypeIcon from 'assets/logotypes/LogotypeIcon'

import { getProfileAvatarSrc } from './utils'

interface UserAvatarProps {
  className?: string
  email?: string
  name?: string
  size?: AvatarProps['size']
  src?: string
  sx?: object
  variant?: 'customer' | 'user' | 'homepal' | 'role' | 'company'
}

const UserAvatar = React.forwardRef((props: UserAvatarProps, ref: any) => {
  const { className, email, name, size, src, sx, variant } = props

  const fontSize =
    size === 'xlarge' ? 'large' : size === 'xsmall' ? 'small' : size

  let icon = null
  let avatarBgColor = undefined

  switch (variant) {
  case 'customer': {
    if (src) {
      icon = <Logotype mode={'dark'} src={src} />
    } else {
      icon = (
        <Icon color="disabled" fontSize={fontSize} name="ApartmentOutlined" />
      )
    }
    avatarBgColor = 'primary.main'
    break
  }
  case 'homepal': {
    avatarBgColor = 'brand.background'
    icon = <LogotypeIcon />
    break
  }
  case 'company': {
    avatarBgColor = 'transparent'
    icon = <Icon color="disabled" fontSize={fontSize} name="Business" />
    break
  }
  }

  const imageSrc = getProfileAvatarSrc(email)

  return (
    <Avatar
      ref={ref}
      alt={variant === 'role' ? '' : name}
      bgcolor={avatarBgColor}
      className={className}
      size={size}
      src={imageSrc}
      sx={{
        ...(imageSrc
          ? {
              bgcolor: 'brand.background',
              ['& .MuiAvatar-img']: {
                WebkitFilter: 'grayscale(100%)',
                filter: 'grayscale(100%)'
              }
            }
          : null),
        ...sx
      }}
    >
      {icon !== null ? icon : name ? name.charAt(0) : null}
    </Avatar>
  )
})

export default UserAvatar
